declare global {
  interface Window {
    __alloyMonitors?: [
      {
        onNetworkResponse?(data: TargetNetworkResponse): void;
        onBeforeNetworkRequest?(data: TargetNetworkResponse): void;
      }
    ];
    targetData?: TargetExperienceMetadataStore[];
  }
}

export interface TargetExperienceMetadataStore {
  activity_name?: string;
  experience_name?: string;
  activity_id?: string,
  experience_id?: string
}

export interface TargetNetworkResponse {
  payload: {
    events: [
      {
        xdm: {
          eventType: string;
        },
        query: {
          personalization: {
            decisionScopes: string[];
          }
        }
      }
    ];
  };
  parsedBody?: {
    handle?: [
      {
        type?: string;
        payload?: AdobeTargetResponsePersonalizationPayload[] | AdobeTargetResponseIdentityPayload[]
      }
    ]
  };
}

export interface AdobeTargetExperienceMetadata {
  'experience.id': string;
  'activity.name': string;
  'profile.tntId': string;
  'geo.state': string,
  'activity.id': string,
  'experience.name': string,
  'geo.zip': string,
  'geo.country': string
}
export interface AdobeTargetResponsePersonalizationPayload {
  id?: string;
  scope?: string;
  items?: [
    {
      meta?: AdobeTargetExperienceMetadata,
      data?: {
        content?: PromoBannerContent | TopLevelMenuContent | HomePageSectionOrder | MealBuilderProteinOrder | AEMGuestOrderCreateAccountFragment | DynamicUpsellContent | MealBuilderItemDetails[] | TopLevelMenuImageContent[] | MealBuilderCustomizationsIntegrationContent;
      }
    }
  ];
  scopeDetails?: any;
}

export interface MealBuilderItemDetails {
  cmgIds: string[],
  itemName: string,
  promoTag: string,
  tagLine: string,
  rewardsText: string,
  isRewardsExclusive: boolean
}

export interface AdobeTargetResponseIdentityPayload {
  id: string,
  namespace: {
    code: string
  }
}

export interface AdobePersonalizationResponsePayload {
  id: string,
  value: string
}

export interface PropositionDisplayPayload {
  propositions:
  {
    id: string,
    scope: string,
    scopeDetails: any, // Putting 'any' here because we are sending back whatever Adobe Target sent to the client
  }[]
}

export interface PromoBannerContent {
  master: AemPromoBanner;
  bannerType: string;
}

export interface DynamicUpsellContent {
  upsellItems: string[];
  upsellTitle: string
}

export interface TopLevelMenuContent {
  firstItem: string;
}

export interface MealBuilderProteinOrder {
  proteinOrder: string[];
}

export interface HomePageSectionOrder {
  isOneTapSectionAboveTopLevelMenu: boolean;
}

export interface TopLevelMenuImageContent {
  topLevelMenuTitle: string;
  thumbnailImageUrl: string;
  bannerImageUrl: string;
}

export interface MealBuilderCustomizationsIntegrationContent {
  target: string;
}

export interface MealBuilderCustomizationsMetadata{
  "activity.id": string;
  "activity.name": string;
  "experience.id": string;
  "experience.name": string;
}

export enum TargetPayloadType {
  Personalization = 'personalization:decisions',
  CmgTarget = 'cmg_target',
  Identity = 'identity:result',
  State = 'state:store'
}

export enum TargetDecisionScope {
  HeroPromoBannerTop = 'hero-promo-banner-top',
  LoyaltyBannerHomePage = 'loyalty-banner-homepage',
  TopLevelMenu = 'top-level-menu',
  TopLevelMenuImage = 'top-level-menu-image',
  DualPromoBanner = 'dual-promo-banner',
  FeaturedMeals = 'featured-meals',
  LargePromoOrder = 'large-promo-order',
  HomePageSectionOrder = 'hp-content-order',
  MealBuilderProteinOrder = 'mb-protein-order',
  MealBuilderItemDetails = 'mb-item-details',
  OrderConfirmationGuest = 'order-confirmation-create-account-banner',
  CartUpsellItems = 'cart-upsell-items-web',
  CartUpsellTitle = 'cart-upsell-title-web',
  MealBuilderCustomizationsIntegration = 'mb-customizations-integration',
  LoyaltyAutoAccrualFlag = 'loyalty-auto-accrual-flag',
  Global = '__view__',
}

export enum TargetIdentityType {
  ECID = 'ECID'
}

export interface UtmParameters {
  utmCampaign: string | (string | null)[];
  utmContent: string | (string | null)[];
  utmMedium: string | (string | null)[];
  utmSource: string | (string | null)[];
  utmTerm: string | (string | null)[];
  adSetId: string | (string | null)[];
}

export enum MealBuilderCustomizationsResponse {
  NotSet = 'NotSet',
  Control = 'Control',
  Variant = 'Variant'
}

export interface MealBuilderExperienceResponse {
  experienceID: string;
  experienceName: string;
  experienceSource: string;
}

